import { render, staticRenderFns } from "./BillingHistory.vue?vue&type=template&id=74b4684e&scoped=true&"
import script from "./BillingHistory.vue?vue&type=script&lang=js&"
export * from "./BillingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BillingHistory.vue?vue&type=style&index=0&id=74b4684e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4684e",
  null
  
)

export default component.exports